import axios from '../../axios';

const service = {
  async signIn(data) {
    return axios({ method: 'post', url: '/auth/login', data });
  },

  async signUp(data) {
    return axios({ method: 'post', url: '/auth/register', data });
  },

  async savePhone(data) {
    return axios({ method: 'post', url: '/auth/send-phone-code', data });
  },

  async verifyEmail(data) {
    return axios({ method: 'post', url: '/auth/verify-email', data });
  },

  async verifyPhone(data) {
    return axios({ method: 'post', url: '/auth/verify-phone', data });
  },

  async verifyToken(payload) {
    return axios({ method: 'post', url: '/password/reset/verify/token', data: payload });
  },

  async sendSetPassword(payload) {
    return axios({ method: 'post', url: '/password/sendSetPassword', data: payload });
  },

  async setPassword(payload) {
    return axios({ method: 'post', url: '/password/setPassword', data: payload });
  },

  async resendEmailCode(data) {
    return axios({ method: 'post', url: '/auth/send-email-code', data });
  },

  async resetPassword(data) {
    return axios({ method: 'post', url: '/password/reset', data });
  },

  async resetEmail(data) {
    return axios({ method: 'post', url: '/password/reset/email', data });
  }
};

export default service;
